import {ShopTracking} from "../shopTracking";

export class ShopTrackingEvents {
    /**
     * @type {string}
     */
    static  CUSTOM_EVENT_ADD_TO_CART = 'trackingAddToCart';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_REMOVE_FROM_CART = 'trackingRemoveFromCart';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_ADD_TO_WISHLIST = 'trackingAddToWishlist';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_REMOVE_FROM_WISHLIST = 'trackingRemoveFromWishlist';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_ADD_TO_REQUEST_CART = 'trackingAddToRequestCart';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_ADD_SHIPPING_INFO = 'trackingAddShippingInfo';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_VIEW_CART = 'trackingViewCart';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_VIEW_ITEM = 'trackingViewItem';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_VIEW_PURCHASE = 'trackingViewPurchase';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_CHECKOUT_STEP_1 = 'trackingViewCheckoutStep1';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_CHECKOUT_STEP_2 = 'trackingViewCheckoutStep2';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_CHECKOUT_STEP_3 = 'trackingViewCheckoutStep3';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_PARAM_PRODUCT_ID = 'productId';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_PARAM_PRODUCT_QUANTITY = 'productQuantity';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_PARAM_PAYLOAD = 'payload';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_PARAM_ELEMENT_TO_START = 'elementToStart';

    /**
     * @type {string}
     */
    static CUSTOM_EVENT_PARMETER_TRACKING_DATA = 'trackingData';

    /**
     * @param eventType
     * @param data
     * @returns {void}
     */
    static dispatchCustomEvent(
        eventType,
        data
    ) {
        if (data.hasOwnProperty(ShopTrackingEvents.CUSTOM_EVENT_PARAM_ELEMENT_TO_START)) {

            data[ShopTrackingEvents.CUSTOM_EVENT_PARMETER_TRACKING_DATA] = ShopTracking.getClosestTrackingData(
                data[ShopTrackingEvents.CUSTOM_EVENT_PARAM_ELEMENT_TO_START] ?? null,
                ShopTracking.DATA_ATTRIBUTE_TRACKING_PRODUCT
            );
        }

        const event = new CustomEvent(
            eventType,
            {
                detail: data
            }
        );

        document.body.dispatchEvent(event);
    }
}